import React, { useContext, useEffect } from "react";
import "./Deposite_History.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Deposite_History_card from "./Deposite_History_card/Deposite_History_card";
import No_data from "../../Common/No_data/No_data";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../../utils/context";
import { GetAllDepositHistory } from "../../../features/wallet/slice";

function Deposite_History() {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { signin } = useContext(Context)

  const depositeHistory = useSelector((state) => state.wallet);


  useEffect(() => {
    if (signin)
      dispatch(GetAllDepositHistory({
      }))
  }, [dispatch, signin])
  return (
    <section className="Withdrawal_History">
      <div className="withdrawal_header History_header">
        <div className="header-left">
          <span className="header_icon">
            <FontAwesomeIcon icon={faFileLines} />
          </span>
          <h4>Deposit History</h4>
        </div>
      </div>
      {depositeHistory?.data?.length > 0 ?
        <Deposite_History_card status="Failed" badge="Deposit" depositeHistory={depositeHistory} />
        :
        <No_data />
      }

      <div className="text-center">
        <Button
          className="btn-register mb-3"
          onClick={() => navigate("/deposite-history")}
        >
          All History
        </Button>
      </div>
    </section>
  );
}

export default Deposite_History;
